/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { Autocomplete, Grid, IconButton, Menu, MenuItem, TextField } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import GradientButton from '../MUICustomButton/GradientButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { ARE_YOU_SURE, DEACTIVATE_TEST_MODE, UNKNOWN_ERR, ACTIVATE_BULK_CAMPAIGN_SUCCESS_MESSAGE, DEACTIVATE_BULK_CAMPAIGN_SUCCESS_MESSAGE, DELETE_BULK_CAMPAIGN, COPY_BULK_CAMPAIGN, CANCEL_BULK_CAMPAIGN, DELETE_BULK_CAMPAIGN_SUCCESS_MESSAGE, COPY_BULK_CAMPAIGN_SUCCESS_MESSAGE, ACTIVATE_TEST_MODE, RESUME_BULK_CAMPAIGN_SUCCESS_MESSAGE, PAUSE_BULK_CAMPAIGN_SUCCESS_MESSAGE, BULK_CAMPAIGN_CANCEL_SUCCESS_MESSAGE } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { RootState, appConfigs } from '../types/types';
import { FormControl } from '@mui/material';
import { getAllBulkEmail, activateDeactivate, deleteBulkEmailCampaign, copyBulkEmailCampaign, updatePauseResumeStatus, cancelBulkEmailCampaign } from 'src/services/bulkEmailServices';
import { exportStandardReport, getCampaignReportData, updateCampaignTestMode } from 'src/services/campaignService';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { getAllBrand } from 'src/services/brandService';
import { getAllGroup } from 'src/services/groupService';
import SendTestEmail from '../SendTestEmail/SendTestEmail';
// import MainLayout from '../Layouts/Mainlayout';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import { MultiplicationSignStrokeStandard } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import TemplatePreview from '../TemplatePreview/TemplatePreview'; // Import your modal component
//@ts-ignore
import { ViewStrokeRounded, Image03Icon } from '@hugeicons-pro/core-stroke-rounded';
import * as EmailValidator from 'email-validator';
import { checkEventPermission } from "../../common/utility/utility";
import ExportCustomReport from '../Campaigns/ExportCustomReport';
import CsvService from 'src/services/dataExport.service';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import { buildReportFileName } from '../utils/buildReportFileName';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
    [`& .${tooltipClasses.arrow}`]: {
        display: 'none',
    },
}));
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


interface ApiResponse {
    status: number;
    data: {
        data: any;
        result: number;
    };
}

interface GroupListPropType {
    "id": number;
    "clientId": number;
    "clientName": string;
    "groupName": string;
    "isDeleted": boolean;
    "createdBy": number;
    "createdByUserName": string;
    "createdOn": string;
    "modifiedBy": number;
    "modifiedOn": string;
    "modifiedByUserName": string;
}

interface GroupApiResponse {
    status: number;
    data: {
        data: GroupListPropType[];
        result: number;
    };
}

function BulkEmailList(): JSX.Element {
    const [bulkEmailListData, setBulkEmailListData] = useState<any[]>([])
    const [bulkEmailSearchData, setBulkEmailSearchData] = useState<any[]>([])
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [perPage, setPerPage] = useState<number>(10)
    const [totalRecords, setTotalRecords] = useState<number>(0)
    const [loading, setLoading] = useState<boolean>(true)
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
    const [templateInfoData, setTemplateInfoData] = useState<any>();
    const [showDeleteTemplateModal, setDeleteTemplateModal] = useState<boolean>(false);
    const [showDeactivateTemplateModal, setDeactivateTemplateModal] = useState<boolean>(false);
    const [showCopyCampaignModal, setCopyCampaignModal] = useState<boolean>(false);
    const [templateId, setTemplateId] = useState<number>(0)
    const [selectedValue, setSelectedValue] = useState<any>({ value: "", label: "Select Status" })
    const [customReportModal, setCustomReportModal] = useState<boolean>(false)
    const [campaingName, setCampaingName] = useState<string>("")

    const [brands, setBrands] = useState<any>([])
    const [groups, setGroups] = useState<any>([])
    const [bulkCampaignId, setBulkCampaignId] = useState<number>(0)
    const [openAPIInformationModal, setOpenAPIInfoModal] = useState<boolean>(false)
    const [searchText, setSearchText] = useState("");
    const [selectedBrand, setSelectedBrand] = useState<any>(null);
    const [selectedGroup, setSelectedGroup] = useState<any>(null);
    const [selectedStatus, setSelectedStatus] = useState<{ value: string; label: string } | null>(null);
    const [testEmailModalOpen, setTestEmailModalOpen] = useState(false);
    const [isCampaignInUse, setisCampaignInUse] = useState(false);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [campaignId, setCampaignId] = useState<number>(0);
    const [updateCancel, setUpdateCancel] = useState(false);

    const [showActivateTestModal, setActivateTestModal] = useState<boolean>(false);
    const [isTestMode, setIsTestMode] = useState<boolean>(false);
    const [emails, setEmails] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [updatePauseResume, setUpdatePauseResume] = useState<boolean>(false);
    const [updateType, setUpdateType] = useState<string>("");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
    const { user } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate()
    const storedAppConfig = localStorage.getItem("appConfigs");

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"));
    // const RoleId = userData.roleID;

    useEffect(() => {
        const ClientId = user?.clientId ?? 0;



        getAllGroup(ClientId)
            .then(
                (res: GroupApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            const webhookArr: GroupListPropType[] = [];
                            res.data.data.map((webhook: any) => {
                                webhook.Name = `${webhook.clientName}`
                                webhookArr.push(webhook)
                            })
                            setGroups(webhookArr)
                        } else {
                            setGroups([])
                        }
                    }
                }
            )
            .catch(
                (error: any) => console.log("Error: ", error)
            )
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        getAllBulkEmailData()
    }, [user])

    const getStatusValue = (statusObj: { value: string; label: string } | null): number | undefined => {
        if (!statusObj) return undefined;
        switch (statusObj.value) {
            case 'active': return 1;
            case 'inactive': return 2;
            case 'cancelled': return 3;
            default: return undefined;
        }
    };

    const getAllBulkEmailData = (): void => {
        setLoading(true);
        const ClientId = user?.clientId ?? 0;

        const trimmedSearch = searchText.trim();
        let searchTypeId: number | undefined;
        let searchCampaignId: number | undefined;
        let searchCampaignName: string | undefined;
        if (trimmedSearch !== '') {
            if (/^\d+$/.test(trimmedSearch)) {
                searchTypeId = 1;
                searchCampaignId = Number(trimmedSearch);
            } else {
                searchTypeId = 2;
                searchCampaignName = trimmedSearch;
            }
        }

        getAllBulkEmail(ClientId, currentPage, perPage, getStatusValue(selectedStatus), searchTypeId, searchCampaignId, searchCampaignName, 'list')
            .then((res: ApiResponse) => {
                if (res.status === 200) {
                    const rawData = res.data.data;
                    let bulkCampaigns: any[];
                    if (Array.isArray(rawData)) {
                        bulkCampaigns = rawData;
                    } else if (rawData && Array.isArray(rawData.data)) {
                        bulkCampaigns = rawData.data;
                    } else if (rawData && Array.isArray(rawData.bulkCampaigns)) {
                        bulkCampaigns = rawData.bulkCampaigns;
                    } else {
                        bulkCampaigns = [];
                    }
                    const bulkEmailArr: any[] = [];
                    bulkCampaigns.forEach((template: any) => {
                        template.Name = `${template.templateName}`;

                        const sends = template.sent ?? 0;
                        const opens = template.open ?? 0;
                        const clicks = template.clicks ?? 0;
                        const unSubscribes = template.unSubscribe ?? 0;

                        template.openRate = sends > 0
                            ? Math.min(parseFloat(((opens * 100.0) / sends).toFixed(2)), 999.99)
                            : 0;
                        template.clickRate = sends > 0
                            ? Math.min(parseFloat(((clicks * 100.0) / sends).toFixed(2)), 999.99)
                            : 0;
                        template.unsubscribeRate = sends > 0
                            ? parseFloat(((unSubscribes * 100.0) / sends).toFixed(2))
                            : 0;
                        template.clickToOpenRate = opens > 0
                            ? parseFloat(((clicks * 100.0) / opens).toFixed(2))
                            : 0;

                        bulkEmailArr.push(template);
                    });
                    setBulkEmailListData(bulkEmailArr);
                    setBulkEmailSearchData(bulkEmailArr);
                    const total = Array.isArray(rawData)
                        ? bulkEmailArr.length
                        : (rawData?.totalCount ?? bulkEmailArr.length);
                    setTotalRecords(total);
                } else {
                    setBulkEmailListData([]);
                    setBulkEmailSearchData([]);
                    setTotalRecords(0);
                }
            })
            .catch((error: any) => {
                console.log("Error: ", error);
                setBulkEmailListData([]);
                setBulkEmailSearchData([]);
                setTotalRecords(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleAddBulkCampaignClick = (): void => {
        navigate('/bulk-email/new-bulk-campaign')
    }


    const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
        // anchorActionEl[id] = event.currentTarget
        setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
    }

    // Update search text
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setSearchText(e.target.value);
    };

    // Handle Status Selection
    const handleTemplateValue = (newValue: { value: string; label: string } | null): void => {
        setSelectedStatus(newValue);
    };

    // Reset to page 1 when filters change
    useEffect(() => {
        setCurrentPage(1);
    }, [searchText, selectedStatus]);

    // Re-fetch from server when page, perPage, or filters change
    useEffect(() => {
        getAllBulkEmailData();
    }, [currentPage, perPage, searchText, selectedStatus]);

    const handlePageChange = (page: number): void => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage: number, page: number): void => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };


    const handleDeleteTemplate = (id: number, templateName: string, isCampaignInUse: boolean): void => {
        setTemplateInfoData({ id, templateName });
        setDeleteTemplateModal(true)
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
        setisCampaignInUse(isCampaignInUse);
    }

    const handleDeleteTemplateClose = (): void => {
        setDeleteTemplateModal(false);
        setisCampaignInUse(false);

    }

    const handleDeleteTemplateConfirm = (): void => {
        setIsModalSaveLoading(true)

        const { id } = templateInfoData;

        const data = {
            "deletedBy": userData.id,
            "bulkCmpgnLst": [
                {
                    "bulkCampaignId": id
                }
            ]
        }
        deleteBulkEmailCampaign(data)
            .then(
                (res: ApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            NotificationManager.success(DELETE_BULK_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                            setDeleteTemplateModal(false)
                            getAllBulkEmailData()
                        }
                    }
                }
            )
            .catch((error: any) => console.log("Error", error))
            .finally(() => setIsModalSaveLoading(false));
        setisCampaignInUse(false);
    }

    const handleActivateTestModeModal = (id: number, templateName: string, isTestMode: boolean): void => {
        setTemplateInfoData({ id, templateName });
        setActivateTestModal(true);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
        setIsTestMode(isTestMode)
    }

    const closeActivateTestModeModal = (): void => {
        setActivateTestModal(false);
        setIsTestMode(false);
        setEmails('')
    }

    const validateEmails = (emailString: string): string => {
        if (emailString.trim() === '') return 'Please enter email address';

        const invalidEmails = !EmailValidator.validate(emailString);

        if (invalidEmails) {
            return `Invalid email format`;
        }

        return '';
    };

    const handleActivateTestModeConfirm = (): void => {
        if (isTestMode === false) {
            const validationError = validateEmails(emails);
            if (validationError !== "") {
                setError(validationError);
                return;
            }
        }


        setIsModalSaveLoading(true)
        const data = {
            "bulkCampaignId": templateInfoData.id,
            "isTestMode": isTestMode === true ? false : true,
            "testEmailRecipient": emails,
            "updatedBy": user?.id
        }
        updateCampaignTestMode(data).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    setActivateTestModal(false)
                    setEmails('')
                    NotificationManager.success(isTestMode ? "Test mode deactivated successfully" : "Test mode activated successfully", '', 5000);
                    getAllBulkEmailData()
                } else {
                    NotificationManager.error(res.data.message, '', 5000);
                }
            }
        })
            .catch((error: any) => {
                console.log("Error", error)
                NotificationManager.error(UNKNOWN_ERR, '', 5000);
            })
            .finally(() => setIsModalSaveLoading(false))
    }

    const handleupdatestatus = (id: number, statusId: boolean, templateName: string, isCampaignInUse: boolean): void => {
        setTemplateInfoData({ id: id, newStatus: statusId, templateName: templateName });

        // Trigger the modal and close any open action menus
        setDeactivateTemplateModal(true);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
        setisCampaignInUse(isCampaignInUse);
    };

    const handleupdatestatusClose = (): void => {
        setDeactivateTemplateModal(false);
        setisCampaignInUse(false);
    }
    const handleUpdateCancel = (id: number): void => {
        console.log("Cancel Clicked", id);
        setTemplateInfoData({ id: id });
        setIsModalSaveLoading(false);
        setUpdateCancel(true)
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
    };

    const handleCancelCampaignConfirm = (): void => {
        setIsModalSaveLoading(true)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const userData = JSON.parse(localStorage.getItem("user"));
        const data = {
            "cancelledBy": userData.id,
            "bulkCampaignId": templateInfoData.id ?? 0,
            "cancel": 1
        }

        cancelBulkEmailCampaign(data)
            .then(
                (res: ApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            NotificationManager.success(BULK_CAMPAIGN_CANCEL_SUCCESS_MESSAGE, '', 5000);
                            setUpdateCancel(false)
                            getAllBulkEmailData()
                        } else {
                            NotificationManager.error(UNKNOWN_ERR, '', 5000);
                            setUpdateCancel(false)
                            setIsModalSaveLoading(false)
                            getAllBulkEmailData()
                        }
                    } else {
                        NotificationManager.error(UNKNOWN_ERR, '', 5000);
                        setUpdateCancel(false)
                        setIsModalSaveLoading(false)
                        getAllBulkEmailData()
                    }
                }
            )
            .catch((error: any) => {
                console.log("Error", error)
                NotificationManager.error(UNKNOWN_ERR, '', 5000);
                setUpdateCancel(false)
            })
            .finally(() => setIsModalSaveLoading(false))


    };

    const handleUpdateCancelClose = (): void => {
        setUpdateCancel(false);
        setIsModalSaveLoading(false);
    }
    const handleUpdateStatusConfirm = (): void => {

        setIsModalSaveLoading(true)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const userData = JSON.parse(localStorage.getItem("user"))
        const { id, newStatus } = templateInfoData;
        const data =
        {
            "updatedBy": userData.id,
            "bulkCmpgnLst": [
                {
                    "bulkCampaignId": id
                }
            ],
            "status": newStatus === true ? 0 : 1
        }
        activateDeactivate(data)
            .then(
                (res: ApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            if (newStatus == false) {
                                NotificationManager.success(ACTIVATE_BULK_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                            } else {
                                NotificationManager.success(DEACTIVATE_BULK_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                                // Adjust the width inline
                                setTimeout(() => {
                                    const notification = document.querySelector('.notification-container') as HTMLElement | null;
                                    if (notification !== null) {
                                        notification.style.width = '340px'; // Set your desired width
                                    }
                                }, 0);
                            }
                            setDeactivateTemplateModal(false)
                            getAllBulkEmailData()
                        } else {
                            setDeactivateTemplateModal(false)
                            //@ts-ignore
                            NotificationManager.error(res.data.messages, '', 5000);
                        }
                    }
                }
            )
            .catch((error: any) => console.log("Error", error))
            .finally(() => setIsModalSaveLoading(false))
    }

    const handleCopyCampaign = (id: number, templateName: string): void => {
        setTemplateInfoData({ id, templateName });
        setCopyCampaignModal(true)
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
    }

    const handleCopyCampaignClose = (): void => {
        setCopyCampaignModal(false)
    }

    const handleCopyCampaignConfirm = (): void => {
        setIsModalSaveLoading(true)

        const { id } = templateInfoData;

        copyBulkEmailCampaign(id, userData.id)
            .then(
                (res: ApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            NotificationManager.success(COPY_BULK_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                            setCopyCampaignModal(false)
                            getAllBulkEmailData()
                        }
                    }
                }
            )
            .catch((error: any) => console.log("Error", error))
            .finally(() => setIsModalSaveLoading(false))
    }

    const handleDownloadReport = (id: any, bulkCampaignName: string): void => {
        getCampaignReportData(id, undefined, undefined, undefined, 'bulkemail')
            .then((res: any) => {
                if (res.status === 200) {
                    if (res.data.result === 1) {
                        const reportData = res.data.data;

                        const data: any = [];
                        if (reportData.length > 0) {

                            reportData.map((item: any) => {
                                const newItem = {
                                    "Campaign Id": item.bulkCampaignId,
                                    "Event Id": item.eventId,
                                    "Event Type": item.eventType,
                                    "Event Time": moment(item.eventTime).format("MM-DD-YYYY HH:mm:ss"),
                                    "Event Data": item.eventData,
                                    "NPI": item.npi,
                                    "Template Id": item.templateId,
                                    "From Name": item.fromName,
                                    "Brand": item.brand,
                                    "Request Id": item.requestId,
                                }

                                data.push(newItem)
                            })


                            const csvData = CsvService.jsonToCsv(data);
                            CsvService.downloadCsvFile(csvData, buildReportFileName(id, bulkCampaignName, 'SummaryReport'));
                        } else {
                            NotificationManager.error('No data available for download', '', 5000);
                        }
                    } else {
                        NotificationManager.error('No data available for download', '', 5000);
                    }
                }
            }).finally(() => {
                setAnchorActionEl({ ...anchorActionEl, [id]: null });
            })

    }

    const handleDownloadStandardReport = (id: any, bulkCampaignName: any): void => {
        exportStandardReport(id, 'bulkemail')
            .then((res: any) => {
                if (res.status === 200) {
                    if (res.data.result === 1) {
                        const reportData = res.data.data;

                        const data: any = [];
                        if (reportData.length > 0) {

                            reportData.map((item: any) => {
                                const newItem = {
                                    "NPI": item.npi,
                                    "First Name": item.firstName,
                                    "Last Name": item.lastName,
                                    "Title": item.title,
                                    "Speciality": item.specialty,
                                    "Event Time": moment(item.eventTime).format("MM-DD-YYYY HH:mm:ss"),
                                    "Event Type": item.eventType,

                                }

                                data.push(newItem)
                            })

                            const csvData = CsvService.jsonToCsv(data);
                            CsvService.downloadCsvFile(csvData, buildReportFileName(id, bulkCampaignName, 'StandardReport'));

                        } else {
                            NotificationManager.error('No data available for download', '', 5000);
                        }
                    } else {
                        NotificationManager.error('No data available for download', '', 5000);
                    }
                }
            }).finally(() => {
                setAnchorActionEl(null);
                setAnchorActionEl({ ...anchorActionEl, [id]: null });
            })
    }

    const handleCustomReport = (campaignId: any, campaingName: string): void => {
        setCampaignId(campaignId);
        setCampaingName(campaingName)
        setCustomReportModal(true)
        setAnchorActionEl({ ...anchorActionEl, [campaignId]: null });
    }

    const handleCloseCustomReport = (): void => {
        setCustomReportModal(false)
    }
    const handleUpdatePauseResumeClose = (): void => {
        setUpdatePauseResume(false)
    }
    const handleUpdatePauseResume = (id: number, type: string): void => {
        console.log(id, type);
        setTemplateInfoData({ id, type });
        setUpdatePauseResume(true);
        setUpdateType(type);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
    }
    console.log(templateInfoData);
    const handleUpdatePauseResumeConfirm = (): void => {
        setIsModalSaveLoading(true)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const userData = JSON.parse(localStorage.getItem("user"));
        const data = {
            "pausedBy": userData.id,
            "bulkCampaignId": templateInfoData.id ?? 0,
            "pause": updateType == "resume" ? 0 : 1
        }

        updatePauseResumeStatus(data)
            .then(
                (res: ApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            if (updateType == "resume") {
                                NotificationManager.success(RESUME_BULK_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                            } else {
                                NotificationManager.success(PAUSE_BULK_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                                // Adjust the width inline
                                setTimeout(() => {
                                    const notification = document.querySelector('.notification-container') as HTMLElement | null;
                                    if (notification !== null) {
                                        notification.style.width = '340px'; // Set your desired width
                                    }
                                }, 0);
                            }
                            setUpdatePauseResume(false)
                            getAllBulkEmailData()
                        } else {
                            NotificationManager.error(UNKNOWN_ERR, '', 5000);
                            setUpdatePauseResume(false)
                            setIsModalSaveLoading(false)
                            getAllBulkEmailData()
                        }
                    } else {
                        NotificationManager.error(UNKNOWN_ERR, '', 5000);
                        setUpdatePauseResume(false)
                        setIsModalSaveLoading(false)
                        getAllBulkEmailData()
                    }
                }
            )
            .catch((error: any) => console.log("Error", error))
            .finally(() => setIsModalSaveLoading(false))
        setLoading(true);

    }
    // Dropdown options
    const options = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'cancelled', label: 'Cancelled' }
    ];
    const handleEditNavigation = (id: number): void => {
        navigate(`/bulk-email/edit-bulk-email/${id}`);
    }

    const handleViewReport = (id: number, start: any, end: any, campaignName: string, brandName: any, groupName: any, type: string, resendDateTimeLst: any[]): void => {
        navigate(`/bulk-email/view-report/${id}`, {
            state: { start, end, campaignName, brandName, groupName, type, resendDateTimeLst },
        });
    };
    const isNumeric = (value: unknown): boolean =>
        typeof value === "number" ||
        (!isNaN(Number(value)) && value !== null && value !== "");

    // Explicit return type added here
    const wrapHeader = (name: string | JSX.Element, sampleValue: unknown): JSX.Element => {
        const numeric = isNumeric(sampleValue);
        return (
            <div style={{ textAlign: numeric ? "center" : "left", width: "100%", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {name}
            </div>
        );
    };
    const columns: TableColumn<any>[] = [
        // Updated Template column with removed padding
        {
            name: 'Template',
            center: true,
            cell: (row: any) => {
                let imageUrl: string | null = null;

                if (storedAppConfig != null) {
                    try {
                        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
                        const TemplateImagePublicURL = parsedAppConfig.find(
                            (item) => item.configName === "TemplateImagePublicURL"
                        )?.configValue;
                        if (TemplateImagePublicURL != '') {
                            imageUrl = `${TemplateImagePublicURL}Template/${row.templateIdentifier}/${row.templateHTMLVersion}/Template_Short.png`;
                        }
                    } catch (error) {
                        console.error("Error parsing appConfig data:", error);
                    }
                }

                const handlePreview = (): void => {
                    setBulkCampaignId(row.bulkCampaignId);
                    setIsPreviewModalOpen(true);
                };

                return (
                    <div className="relative w-[90px] h-[90px] flex items-center justify-center cursor-pointer" onClick={handlePreview}>
                        {(imageUrl != null) ? (
                            <img
                                src={imageUrl}
                                width={90}
                                height={90}
                                alt="Template"
                                className="icon-hover"
                                onLoad={(e) => {
                                    e.currentTarget.style.display = 'block';
                                }}
                                onError={(e) => {
                                    e.currentTarget.style.display = 'none';
                                    const iconElement = e.currentTarget.nextElementSibling as HTMLElement;
                                    if (iconElement) iconElement.style.display = 'flex';
                                }}
                                style={{ borderRadius: '8px', objectFit: 'cover' }}
                            />
                        ) : null}
                        <HugeiconsIcon
                            icon={Image03Icon}
                            size={24}
                            color="#3a3a3a"
                            className="hidden"
                        />
                        <div className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg ${row.templateContent !== "" ? 'hover:opacity-100 transition-opacity cursor-pointer' : ''}`}>
                            <HugeiconsIcon
                                icon={ViewStrokeRounded}
                                size={24}
                                color="white"
                                strokeWidth={0.5}
                                className={`cursor-pointer ${(row.templateContent === "") ? 'opacity-50 cursor-not-allowed' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handlePreview();
                                }}
                            />
                        </div>
                    </div>
                );
            },
            width: '10%',
            sortable: false,
        },
        {
            name: 'Campaign',
            selector: (row: any) => row.bulkCampaignName,
            cell: (row: any) => {
                const startDate = moment(row.bulkCampaignStartDate).format('MM/DD/YYYY hh:mm A');
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <CustomTooltip title={row.bulkCampaignName} placement="bottom">
                                <p
                                    className="text-14 font-semibold underline leading-[22px] cursor-pointer text-muted"
                                    onClick={() => handleEditNavigation(row.bulkCampaignId)}
                                    style={{
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}
                                >
                                    {row.bulkCampaignName}
                                </p>
                            </CustomTooltip>
                            <p className="text-14 text-muted">
                                <span className='font-semibold'>ID:</span> {row.bulkCampaignId}
                            </p>
                            {(checkEventPermission('BULKEMAIL_VIEW_REPORT')) && (
                                <div className="badge truncate" style={{
                                    background: '#FFF5F6',
                                    padding: '10px 15px',
                                    color: '#F13139',
                                    border: '0px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    marginTop: '10px'
                                }}
                                    onClick={() => handleViewReport(row.bulkCampaignId, startDate, null, row.bulkCampaignName, null, null, 'bulkemail', row.resendDateTimeLst)}>View Report</div>
                            )}
                        </div>
                    </div>
                );
            },
            width: '14%',
            sortable: true
        },
        {
            name: 'Schedule',
            selector: (row: any) => row.bulkCampaignName,
            cell: (row: any) => {
                const formatDateTime = (dateString: string): string => {
                    const date = new Date(dateString);
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    const year = date.getFullYear();
                    let hours = date.getHours();
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const ampm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12 || 12; // Convert to 12-hour format

                    return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
                };

                return (
                    <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
                        <div className="overflow-hidden w-full">
                            <div className="mt-2">
                                {[{ resendDateTime: row.bulkCampaignStartDate }, ...(row.resendDateTimeLst || [])].map((resend: any, index: number) => {
                                    const formattedDate = formatDateTime(resend.resendDateTime);
                                    return (
                                        <BootstrapTooltip key={index} title={formattedDate}>
                                            <p className="text-14 text-muted truncate">
                                                {index + 1}. {formattedDate}
                                            </p>
                                        </BootstrapTooltip>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                );
            },
            width: '14%',
            sortable: true
        },

        {
            name: 'Status',
            selector: (row: any) => row.isActive,
            center: true,
            width: '12%',
            cell: (row: any) => {
                if (row.isCancelled === true) {
                    return (
                        <div className="badge truncate" style={{ background: '#FFF2C2', padding: '10px 15px', color: '#FF7A00', border: '0px' }}>Cancelled</div>
                    );
                } else {
                    if (row.isTestMode === true) {
                        return (
                            <div className="badge truncate" style={{ background: '#D9DBF9', padding: '10px 15px', color: '#191975', border: '0px', }}>Test</div>
                        );
                    }
                    return row.isActive === true ? (
                        <div className="badge truncate" style={{ background: '#CCFFEA', padding: '10px 15px', color: '#06A864', border: '0px' }}>Active</div>
                    ) : (
                        <div className="badge truncate" style={{ background: '#FFF5F6', padding: '10px 15px', color: '#F13139', border: '0px' }}>Inactive</div>
                    );
                }
            }
        },
        {
            name: wrapHeader('Target', 0),
            cell: (row: any) => {
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <p className="text-14 text-muted"><span className='font-semibold'>{row.targets}</span></p>
                        </div>
                    </div>
                )
            },
            width: '10%',
            sortable: false
        },
        {
            name: wrapHeader('Opens', 0),
            sortable: false,
            width: "10%",
            cell: (row: any) => {
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <p className="text-14 text-muted"><span className='font-semibold'>{row.open}</span></p>
                            <p className="text-14 text-muted">{row.openRate}%</p>
                        </div>
                    </div>
                )
            },
        },
        {
            name: wrapHeader('Clicks', 0),
            // selector: (row: any) => row.fromName,
            width: '10%',
            cell: (row: any) => {
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <p className="text-14 text-muted"><span className='font-semibold'>{row.clicks}</span></p>
                            <p className="text-14 text-muted">{row.clickRate}%</p>
                        </div>
                    </div>
                )
            },
            // sortable: true
        },
        {
            name: 'Unsubscribes',
            selector: (row: any) => row.unSubscribe,
            width: '10%',
            cell: (row: any) => {
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }} title={row.unsubscribeRate}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <p className="text-14 text-muted"><span className='font-semibold'>{row.unSubscribe}</span></p>
                            <p className="text-14 text-muted">{row.unsubscribeRate}%</p>
                        </div>
                    </div>
                )
            },
        },
        {
            name: wrapHeader('Actions', 0),
            cell: (row: any) => {
                return (
                    <div className='flex items-center'>
                        <div className="icon-hover-container">
                            <Link to={{ pathname: `/bulk-email/edit-bulk-email/${row.bulkCampaignId}` }} state={{ campaigndata: row }} style={{ width: '20px' }}>
                                {/* <img src={'/assets/images/icons/EditIcon.svg'} width={20} height={20} alt="Edit Campaign" className="icon-hover" /> */}
                                <HugeiconsIcon
                                    icon={PencilEdit02Icon}
                                    size={20}
                                    color="#3A3A3A"
                                    strokeWidth={0.2}
                                />
                            </Link>
                        </div>

                        <div className='flex'>
                            {(checkEventPermission('BULKEMAIL_ACTIVATE') || checkEventPermission('BULKEMAIL_DUPLICATE') || checkEventPermission('BULKEMAIL_SEND_TEST_EMAIL') || checkEventPermission('BULKEMAIL_DELETE') || checkEventPermission('BULKEMAIL_DOWNLOAD_REPORT')
                                || checkEventPermission('BULKEMAIL_DOWNLOAD_STANDARD_REPORT') || checkEventPermission('BULKEMAIL_DOWNLOAD_CUSTOM_REPORT')) &&
                                <IconButton
                                    aria-label="more"
                                    id="long-button"
                                    // aria-controls={open ? 'long-menu' : undefined}
                                    // aria-expanded={open ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={(e) => handleActionClick(e, row.bulkCampaignId)}
                                >
                                    <HugeiconsIcon
                                        icon={MoreVerticalSolidRounded}
                                        size={20}
                                        color="#3A3A3A"
                                        strokeWidth={0.2}
                                    />
                                </IconButton>
                            }
                            <Menu
                                id={`${row.bulkCampaignId}`}
                                className='table-action-menu'
                                MenuListProps={{
                                    'aria-labelledby': 'long-button',
                                }}
                                anchorEl={anchorActionEl[row.bulkCampaignId]}
                                open={Boolean(anchorActionEl[row.bulkCampaignId])}
                                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.bulkCampaignId]: null })}
                                slotProps={{
                                    paper: {
                                        style: {
                                            maxHeight: 'none',
                                            width: '19ch',
                                        },
                                    }
                                }}
                            >
                                {checkEventPermission('BULKEMAIL_ACTIVATE') && row.isCancelled !== true &&
                                    <>
                                        {row.isActive === true && (
                                            <>

                                                <MenuItem onClick={() => handleupdatestatus(row.bulkCampaignId, row.isActive, row.bulkCampaignName, row.isCampaignInUse)}>
                                                    <span className="text-muted font-normal">Deactivate</span>
                                                </MenuItem>
                                            </>
                                        )}

                                        {row.isActive === false && (
                                            <MenuItem onClick={() => handleupdatestatus(row.bulkCampaignId, row.isActive, row.bulkCampaignName, row.isCampaignInUse)}>
                                                <span className="text-muted font-normal">Activate</span>
                                            </MenuItem>
                                        )}

                                    </>

                                }

                                {checkEventPermission('BULKEMAIL_UPDATE') && row.isCancelled !== true &&
                                    <>
                                        {row.isActive === true && (
                                            <>
                                                {row.isPaused === true ? (
                                                    <MenuItem onClick={() => handleUpdatePauseResume(row.bulkCampaignId, 'resume')}>
                                                        <span className="text-muted font-normal">Resume</span>
                                                    </MenuItem>

                                                ) : (

                                                    <MenuItem onClick={() => handleUpdatePauseResume(row.bulkCampaignId, 'pause')}>
                                                        <span className="text-muted font-normal">Pause</span>
                                                    </MenuItem>
                                                )
                                                }
                                            </>
                                        )}

                                    </>
                                }
                                {row.isCancelled !== true && checkEventPermission('BULKEMAIL_UPDATE') && (
                                    <MenuItem onClick={() => handleUpdateCancel(row.bulkCampaignId)}>
                                        <span className="text-muted font-normal">Cancel</span>
                                    </MenuItem>
                                )}

                                {checkEventPermission('BULKEMAIL_DUPLICATE') &&
                                    <MenuItem onClick={() => handleCopyCampaign(row.bulkCampaignId, row.bulkCampaignName)}>
                                        <span className='text-muted font-normal'>Duplicate</span>
                                    </MenuItem>
                                }
                                {checkEventPermission('BULKEMAIL_DOWNLOAD_REPORT') &&
                                    <MenuItem onClick={() => handleDownloadReport(row.bulkCampaignId, row.bulkCampaignName as string)}>
                                        <span className='text-muted font-normal'>Summary Report</span>
                                    </MenuItem>
                                }
                                {checkEventPermission('BULKEMAIL_DOWNLOAD_STANDARD_REPORT') &&
                                    <MenuItem onClick={() => handleDownloadStandardReport(row.bulkCampaignId, row.bulkCampaignName)}>
                                        <span className='text-muted font-normal'>Standard Report</span>
                                    </MenuItem>
                                }
                                {checkEventPermission('BULKEMAIL_DOWNLOAD_CUSTOM_REPORT') &&
                                    <MenuItem onClick={() => handleCustomReport(row.bulkCampaignId, row.bulkCampaignName)}>
                                        <span className='text-muted font-normal'>Custom Report</span>
                                    </MenuItem>
                                }

                                {checkEventPermission('BULKEMAIL_SEND_TEST_EMAIL') && row.isActive === true &&
                                    <MenuItem onClick={() => handleSendTestEmailModal(row.bulkCampaignId, row.templateId)} >
                                        <span className='text-muted font-normal'>Send Test Email</span>
                                    </MenuItem>
                                }

                                {checkEventPermission('BULKEMAIL_DELETE') &&

                                    <span> {/* Wrap in a span to ensure proper behavior when disabled */}
                                        <MenuItem
                                            onClick={() => handleDeleteTemplate(row.bulkCampaignId, row.bulkCampaignName, row.isCampaignInUse)}
                                            disabled={row.isCampaignInUse || moment(row.startOn).isBefore(moment())} // Disable based on conditions
                                        >
                                            <span
                                                style={{

                                                    color: row.isCampaignInUse || moment(row.startOn).isBefore(moment()) ? '#aaa' : '#F13139', // Greyed out if disabled
                                                    cursor: row.isCampaignInUse || moment(row.startOn).isBefore(moment()) ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                Delete
                                            </span>
                                        </MenuItem>
                                    </span>

                                }
                            </Menu>
                        </div>

                    </div>
                )
            },
            center: true,
            sortable: false
        },

    ]

    const DeleteModal = (): JSX.Element => {
        if (isCampaignInUse) {
            return (
                <BootstrapDialog
                    onClose={handleDeleteTemplateClose}
                    aria-labelledby="customized-dialog-title"
                    open={showDeleteTemplateModal}
                    PaperProps={{
                        sx: {
                            width: '550px',
                            height: '200px'
                        },
                    }}
                >
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        Delete Bulk Email
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleDeleteTemplateClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>The bulk email <span className='font-semibold'>{templateInfoData?.templateName}</span> is currently in use</p>
                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={handleDeleteTemplateClose} width='100px'>Close</OutlineButton>
                    </DialogActions>
                </BootstrapDialog>
            );
        }

        return (
            <BootstrapDialog
                onClose={handleDeleteTemplateClose}
                aria-labelledby="customized-dialog-title"
                open={showDeleteTemplateModal}
                PaperProps={{
                    sx: {
                        width: '550px',
                        height: '200px'
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                    Delete Bulk Email
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleDeleteTemplateClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <HugeiconsIcon
                        icon={MultiplicationSignStrokeStandard}
                        size={24}
                        color="currentcolor"
                        strokeWidth={0.5}
                    />
                </IconButton>
                <DialogContent>
                    <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_BULK_CAMPAIGN} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                </DialogContent>
                <DialogActions sx={{ background: '#F9F9F9' }}>
                    <OutlineButton color='gray' onClick={handleDeleteTemplateClose} width='100px'>Cancel</OutlineButton>
                    <GradientButton type='button' color='red' onClick={handleDeleteTemplateConfirm} width='100px'>
                        {!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}
                    </GradientButton>
                </DialogActions>
            </BootstrapDialog>
        );
    };

    const StatusUpdateModal = (): JSX.Element => {
        if (isCampaignInUse) {
            return (
                <BootstrapDialog
                    onClose={handleupdatestatusClose}
                    aria-labelledby="customized-dialog-title"
                    open={showDeactivateTemplateModal}
                    PaperProps={{ sx: { width: '550px', height: '200px' } }}
                >
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        {templateInfoData?.newStatus === true ? "Deactivate Bulk Email" : "Activate Bulk Email"}
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleupdatestatusClose}
                        sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                    >
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>The bulk email <span className='font-semibold'>{templateInfoData?.templateName}</span> is currently in use</p>
                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={handleupdatestatusClose} width='100px'>Close</OutlineButton>
                    </DialogActions>
                </BootstrapDialog>
            );
        }
        return (
            <BootstrapDialog
                onClose={handleupdatestatusClose}
                aria-labelledby="customized-dialog-title"
                open={showDeactivateTemplateModal}
                PaperProps={{ sx: { width: '550px', height: '200px' } }}
            >
                <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                    {templateInfoData?.newStatus === true ? "Deactivate Bulk Email" : "Activate Bulk Email"}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleupdatestatusClose}
                    sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                >
                    <HugeiconsIcon
                        icon={MultiplicationSignStrokeStandard}
                        size={24}
                        color="currentcolor"
                        strokeWidth={0.5}
                    />
                </IconButton>
                <DialogContent>
                    <p className='text-14 text-muted'>{ARE_YOU_SURE} {templateInfoData?.newStatus === true ? "deactivate" : "activate"} the bulk campaign <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                </DialogContent>
                <DialogActions sx={{ background: '#F9F9F9' }}>
                    <OutlineButton color='gray' onClick={handleupdatestatusClose} width='130px'>Cancel</OutlineButton>
                    <GradientButton
                        type='button'
                        color='red'
                        onClick={handleUpdateStatusConfirm}
                        width='130px'
                    >
                        {!isModalSaveLoading ? (templateInfoData?.newStatus === true ? "Deactivate" : "Activate") : (
                            <span className="loading loading-spinner loading-xs text-white"></span>
                        )}
                    </GradientButton>
                </DialogActions>
            </BootstrapDialog>
        );
    };

    const handleSendTestEmailModal = (id: number, templateId: number): void => {
        setTestEmailModalOpen(true);
        setAnchorActionEl(null);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
        setTemplateId(templateId);
        setBulkCampaignId(id);
    }
   console.log(bulkEmailListData);
    return (
        <>
            <h2 className="text-2xl font-semibold text-title">Bulk Email Overview</h2>
            <div className="mt-[20px] mb-[20px] live-outreach-container">
                <Grid container spacing={2} alignItems={'center'}>
                    <Grid item xs={12} md={4}>
                        <div className="flex flex-col basis-3/5">
                            <input
                                type="text"
                                placeholder="Search by campaign name or id"
                                className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full"
                                onChange={handleSearch}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} md={4} >

                        <div className='mr-[20px] status-autocomplete'>
                            <FormControl fullWidth sx={{ width: '200px' }}>
                                <Autocomplete
                                    options={options}
                                    getOptionLabel={(option) => option.label}
                                    popupIcon={
                                        <HugeiconsIcon
                                            icon={ArrowDown01Icon}
                                            size={18}
                                            color="#3A3A3A"
                                            strokeWidth={0.2}

                                        />
                                    }
                                    onChange={(event, newValue) => handleTemplateValue(newValue)}
                                    //disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Status"
                                            variant="outlined"
                                            placeholder="Select Status"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '40px',
                                                    height: '40px',
                                                    width: '200px', // Increased width
                                                },
                                            }}
                                        />
                                    )}
                                    sx={{
                                        '& .MuiAutocomplete-clearIndicator': {
                                            marginRight: '-12px'
                                        },
                                        '& .MuiAutocomplete-input': {
                                            width: '70%'
                                        }
                                    }}

                                />
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={4} className="flex justify-end">
                        {checkEventPermission('BULKEMAIL_ADD') &&
                            <div className="justify-end flex">
                                <GradientButton color='red' onClick={handleAddBulkCampaignClick}>
                                    <span style={{
                                        width: "20px",
                                        height: "20px",
                                        background: "#fff",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "50px",
                                        marginRight: "5px"
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                                            <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                                            <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                                        </svg>
                                    </span>
                                    Add New Bulk Email
                                </GradientButton>
                            </div>
                        }
                    </Grid>
                </Grid>
            </div>

            <div className='data-table-container campaign-table mb-10 template-table-container'>
                <CustomDataTable
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    columns={columns}
                    data={bulkEmailSearchData}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRecords}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={perPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    //   selectableRows
                    progressPending={loading}
                />




                <BootstrapDialog onClose={closeActivateTestModeModal} aria-labelledby="customized-dialog-title" open={showActivateTestModal} PaperProps={{ sx: { width: '650px', height: 'auto' }, }}>
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        {isTestMode === true ? "Deactivate Test Mode" : "Activate Test Mode"}
                    </DialogTitle>
                    <IconButton aria-label="close" onClick={closeActivateTestModeModal} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>{ARE_YOU_SURE} {isTestMode === false ? ACTIVATE_TEST_MODE : DEACTIVATE_TEST_MODE} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                        {
                            isTestMode === false && (
                                <React.Fragment>
                                    <TextField
                                        fullWidth
                                        // multiline
                                        sx={{ pb: 2, marginTop: '10px' }}
                                        // rows={3} // Set to exactly 3 rows
                                        value={emails}
                                        onChange={(e) => {
                                            setEmails(e.target.value);
                                            setError('');
                                        }}
                                        placeholder="Please enter recipient email address"
                                        error={Boolean(error)}
                                    />
                                    {error !== "" && (
                                        <div className="flex absolute text-primary ml-1 mb-2 text-md font-normal" style={{ marginTop: '-7px' }}>
                                            <img src="/assets/images/attention.svg" alt="Attention" width={12} height={12} className="mr-1" />
                                            {error.length > 50 ? `${error.substring(0, 50)}...` : error}
                                        </div>
                                    )}
                                </React.Fragment>
                            )
                        }

                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={closeActivateTestModeModal} width='100px'>Cancel</OutlineButton>
                        <GradientButton type='button' color='red' onClick={handleActivateTestModeConfirm} width='100px'>{!isModalSaveLoading ? `${isTestMode === false ? 'Activate' : 'Deactivate'}` : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                    </DialogActions>
                </BootstrapDialog>
                <BootstrapDialog onClose={handleCopyCampaignClose} aria-labelledby="customized-dialog-title" open={showCopyCampaignModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        Duplicate Bulk Email
                    </DialogTitle>
                    <IconButton aria-label="close" onClick={handleCopyCampaignClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>{ARE_YOU_SURE} {COPY_BULK_CAMPAIGN} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={handleCopyCampaignClose} width='100px'>Cancel</OutlineButton>
                        <GradientButton type='button' color='red' onClick={handleCopyCampaignConfirm} width='100px'>{!isModalSaveLoading ? 'Duplicate' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                    </DialogActions>
                </BootstrapDialog>

                <BootstrapDialog onClose={handleUpdateCancelClose} aria-labelledby="customized-dialog-title" open={updateCancel} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        Cancel Bulk Email
                    </DialogTitle>
                    <IconButton aria-label="close" onClick={handleUpdateCancelClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>{ARE_YOU_SURE} {CANCEL_BULK_CAMPAIGN} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={handleUpdateCancelClose} width='100px'>Cancel</OutlineButton>
                        <GradientButton type='button' color='red' onClick={handleCancelCampaignConfirm} width='100px'>{!isModalSaveLoading ? 'Update' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                    </DialogActions>
                </BootstrapDialog>

                <BootstrapDialog onClose={handleUpdatePauseResumeClose} aria-labelledby="customized-dialog-title" open={updatePauseResume} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        {updateType === "resume" ? "Resume Campaign" : "Pause Campaign"}
                    </DialogTitle>
                    <IconButton aria-label="close" onClick={handleUpdatePauseResumeClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>{ARE_YOU_SURE}{" "}{updateType === "resume" ? "resume the campaign" : "pause the campaign"}{" "}<span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                    </DialogContent>

                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={handleUpdatePauseResumeClose} width='130px'>Cancel</OutlineButton>
                        <GradientButton type='button' color='red' onClick={handleUpdatePauseResumeConfirm} width='130px'>{!isModalSaveLoading ? (updateType === "resume" ? "Resume" : "Pause") : (<span className="loading loading-spinner loading-xs text-white"></span>)}</GradientButton>
                    </DialogActions>

                </BootstrapDialog>
                {showDeleteTemplateModal && <DeleteModal />}
                {showDeactivateTemplateModal && <StatusUpdateModal />}
            </div>
            <TemplatePreview
                isOpen={isPreviewModalOpen}
                onClose={() => setIsPreviewModalOpen(false)}
                content={""}
                campaignType="BulkCampaign"
                campaignId={bulkCampaignId}
            />
            <SendTestEmail open={testEmailModalOpen} onClose={() => setTestEmailModalOpen(false)} Type={"BulkCampaign"} TypeId={bulkCampaignId} TemplateId={templateId} />

            <MUIModal title='Download Custom Report' openModal={customReportModal} closeModal={handleCloseCustomReport} width={'50%'} >
                <ExportCustomReport closeModal={handleCloseCustomReport} id={campaignId} name={campaingName} type={"bulkemail"} />
            </MUIModal>



        </>
    );
}

export default BulkEmailList